<div
  dropzone
  (dropped)="onGetFile($event)"
  class="gl-documents-upload"
  [ngClass]="{ loading: previewFile, disabled: disabled }"
>
  <ng-container *ngIf="!previewFile">
    <span class="glicon-documents-upload"></span>
    <span class="label">{{ 'actions.dragAndDropDocument' | translate }}</span>
    <span class="link">
      <label class="select-img-text" [for]="id" [innerHtml]="'actions.uploadDocument' | translate"> </label>
      <input
        [id]="id"
        class="upload-img"
        type="file"
        name="uploadLargeImg"
        [accept]="accept"
        (change)="onGetFile($event)"
      />
    </span>
    <span class="separator"></span>
    <span class="label small">{{ 'actions.dragAndDropMaxDocumentSize' | translate }}</span>
    <span *ngIf="!previewFile && !!maxSizeInMB" class="label small">{{
      'actions.dragAndDropValidFileDocuments' | translate
    }}</span>
    <span class="label small">{{ 'actions.dragAndDropValidFileDocuments' | translate }} </span>
  </ng-container>
  <div *ngIf="previewFile" class="gl-documents-upload__file">
    <div class="gl-documents-upload__file--progress">
      <div class="gl-documents-upload__file--info">
        <div class="name">
          <span class="glicon-documents-upload"></span>
          <span class="text-ellipsis" title="{{ document.name }}">{{ document.name }}</span>
        </div>
        <div class="load" [ngClass]="{ success: previewFile }">
          <span>100%</span>
          <!-- <span *ngIf="!loading" class="glicon-close-circle"></span> -->
          <span class="glicon-check-circle"></span>
        </div>
      </div>
      <div class="gl-documents-upload__file--loader">
        <span style="width: 100%"></span>
      </div>
    </div>
    <div class="gl-documents-upload__file--delete" (click)="deleteDocument()">
      <span class="glicon-trash"></span>
    </div>
  </div>
</div>
